import { PageId } from 'constants/pages'

export const enum PageIdWoofzSmdBl {
  DOG_AGE_SMD_BL = PageId.DOG_AGE_SMD_BL,
  DOG_SEX_SMD_BL = PageId.DOG_SEX_SMD_BL,
  DOG_BREED_SMD_BL = PageId.DOG_BREED_SMD_BL,
  URGE_SMD_BL = PageId.URGE_SMD_BL,
  GOALS_SMD_BL = PageId.GOALS_SMD_BL,
  URGE_1_SMD_BL = PageId.URGE_1_SMD_BL,
  AGRESSIVE_BEHAVIOR_SMD_BL = PageId.AGRESSIVE_BEHAVIOR_SMD_BL,
  TRIGGERS_SMD_BL = PageId.TRIGGERS_SMD_BL,
  URGE_2_SMD_BL = PageId.URGE_2_SMD_BL,
  BEHAVIOR_ISSUES_SMD_BL = PageId.BEHAVIOR_ISSUES_SMD_BL,
  DOG_LISTEN_SMD_BL = PageId.DOG_LISTEN_SMD_BL,
  COMMANDS_SMD_BL = PageId.COMMANDS_SMD_BL,
  EAT_OFF_THE_GROUND_SMD_BL = PageId.EAT_OFF_THE_GROUND_SMD_BL,
  DOG_ACT_SMD_BL = PageId.DOG_ACT_SMD_BL,
  DOG_OFF_AT_HOME_SMD_BL = PageId.DOG_OFF_AT_HOME_SMD_BL,
  PREPARE_SCREEN_SMD_BL = PageId.PREPARE_SCREEN_SMD_BL,
  DOG_PROFILE_SMD_BL = PageId.DOG_PROFILE_SMD_BL,
  HEAR_ABOUT_WOOFZ_SMD_BL = PageId.HEAR_ABOUT_WOOFZ_SMD_BL,
  MANNERS_TO_BUILD_SMD_BL = PageId.MANNERS_TO_BUILD_SMD_BL,
  FEEL_BETTER_SMD_BL = PageId.FEEL_BETTER_SMD_BL,
  PREPARE_FLOW_SMD_BL = PageId.PREPARE_FLOW_SMD_BL,
  EMAIL_SMD_BL = PageId.EMAIL_SMD_BL,
  NEWSLETTER_URGE_SMD_BL = PageId.NEWSLETTER_URGE_SMD_BL,
  SCRATCH_SCREEN_SMD_BL = PageId.SCRATCH_SCREEN_SMD_BL,
  SUBSCRIPTIONS_SMD_BL = PageId.SUBSCRIPTIONS_SMD_BL,
  CHAT_UPSELL_SMD_BL = PageId.CHAT_UPSELL_SMD_BL,
  UPSELL_SMD_BL = PageId.UPSELL_SMD_BL,
  UPSELL_FEEDING_GUIDE_SMD_BL = PageId.UPSELL_FEEDING_GUIDE_SMD_BL,
  UPSELL_EMOTIONAL_SUPPORT_SMD_BL = PageId.UPSELL_EMOTIONAL_SUPPORT_SMD_BL,
  DOWNLOAD_SMD_BL = PageId.DOWNLOAD_SMD_BL,
  ACCOUNT_SMD_BL = PageId.ACCOUNT_SMD_BL,
}
